import { useDispatch, useSelector } from 'react-redux';
import { useState, useEffect, ChangeEvent } from 'react';
import Pager from 'components/pager';
import { Link } from 'react-router-dom';
import './clients.scss';
import { ClientType, RootState } from 'types';
import { actions } from 'redux/reducers';

function Clients() {
    const dispatch = useDispatch();
    const state = useSelector((state: RootState) => state);
    const [clients, setClients] = useState<ClientType[]>([]);
    const [page, setPage] = useState(1);
    const [numberOfElements, setNumberOfElements] = useState(12);

    const search = (e: ChangeEvent<HTMLInputElement>) => {
        setPage(1);
        setClients(state.clients.filter((x: ClientType) => x.Name.toLowerCase().includes(e.currentTarget.value.toLowerCase())));
    }

    function getNumOfElements() {
        if (window.innerWidth > 1400) {
            setNumberOfElements(25);
        } else if (window.innerWidth > 1200) {
            setNumberOfElements(16);
        } else {
            setNumberOfElements(12);
        }
    }

    useEffect(() => {
        setClients(state.clients);
        getNumOfElements();
        dispatch(actions.boards.set([]));
    }, [state.clients, dispatch]);

    return (
        <div id="clients">
            <div id="top">
                Clients
                <div className="input-group">
                    <input type="text" placeholder="Search" onChange={search} />
                    <i className="fal fa-search"></i>
                </div>
            </div>
            <div id="clients-container">
                {clients.slice((page - 1) * numberOfElements, (page - 1) * numberOfElements + numberOfElements).map((item: any) => {
                    return (
                        <Link to={`client/${item.Id}/dashboard`} key={item.Id}>
                            <div className="client">
                                <span className="name" title={item.Name}>{item.Name}</span>
                                <span className="id">{item.Id}</span>
                                <span className="active">Active</span>
                                <i className="fal fa-building"></i>
                            </div>
                        </Link>
                    )
                })}
            </div>
            <div id="paging">
                <Pager 
                    elements={clients}
                    page={page}
                    setPage={setPage}
                    numberOfResults={numberOfElements}
                />
            </div>
        </div>
    )
}

export default Clients;